module.exports = __webpack_public_path__ + "static/website_options-68694c843d91da807c6dd45c51a13ab8.png";